<div *ngIf="showMaintainAlert()">
    <p class="offline-title color-light text-align-center font-16">
        <span *ngIf="subtitles.language === 'pl'">
          W związku z pracami serwisowymi {{startAlertDate()}} do {{stopAlertDate()}} mogą wystąpić problemy w dostępie do platformy.
          Za wszystkie utrudnienia przepraszamy.
        </span>
        <span *ngIf="subtitles.language !== 'pl'">
          There may be problems in accessing the platform from {{startAlertDate()}} GMT until {{stopAlertDate()}} GMT due to maintenance.
          We apologize for all the inconvenience.
        </span>
    </p>
</div>
